module.exports = __webpack_public_path__ + "img/no-record-found.3cd86316.png";